import '@shopify/polaris/build/esm/styles.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css'
import App from './App'
import { initializeShopifyApp } from './utils/shopifyApp';

initializeShopifyApp();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);
